export const KEYBOARD_KEY = {
  Escape: 'Escape',
  Tab: 'Tab',
} as const;
